import { KlevuTypeOfRecord } from "../../index.js";
import { search } from "../search/search.js";
/**
 * Search helper function that sets correct settings
 *
 * @category RecommendationQuery
 * @param term cms page to find
 * @param options
 * @returns
 */
export function searchCms(term, options) {
    return search(term, Object.assign({ typeOfRecords: [KlevuTypeOfRecord.Cms], groupBy: "name" }, options));
}
